// extracted by mini-css-extract-plugin
export default {"modal-container":"client-components-common-teamErrorModal-___teamErrorModal__modal-container___1O-UD"};